<template>
  <gsp-tooltip v-if="showEl">
    <slot />
  </gsp-tooltip>
</template>

<script setup>
import showElOnMounted from "~/composables/show-el-on-mounted";

const showEl = showElOnMounted();
</script>
